import { useTranslation } from 'react-i18next';

export interface ServiceTypeOption {
  value: string;
  labelKey: string;
  disabled?: boolean;
  disabledLabel?: string;
}

interface ServiceTypeSelectorProps {
  selectedValue: string;
  onChange: (value: string) => void;
  options: ServiceTypeOption[];
  className?: string;
  leadTextKey?: string;
}

export const ServiceTypeSelector = ({
  selectedValue,
  onChange,
  options,
  className = 'mb-8',
  leadTextKey = 'reservation.title',
}: ServiceTypeSelectorProps) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className="reservation-card__body">
        {!selectedValue && (
          <div className="reservation-card__lead">{t(leadTextKey)}</div>
        )}
        <div className="reservation-card__services">
          {options.map((option) => {
            const isShower =
              option.value === 'shower_room' || option.value === 'shower';
            const serviceType = isShower ? 'shower' : 'booth';
            const isSelected = selectedValue === option.value;
            const isShowerSelected =
              selectedValue === 'shower_room' || selectedValue === 'shower';
            const isBoothSelected =
              selectedValue === 'private_room' || selectedValue === 'booth';

            return (
              <div
                key={option.value}
                className={`reservation-card__service reservation-card__service--${serviceType} ${
                  isSelected ? 'reservation-card__service--selected' : ''
                }`}
                data-history-target={serviceType}
                onClick={() => !option.disabled && onChange(option.value)}
                style={{ cursor: option.disabled ? 'not-allowed' : 'pointer' }}
              >
                <div className="relative">
                  <img
                    className="reservation-card__service-image"
                    src={
                      isShower
                        ? `/Common_Icon_Service_Shower${!selectedValue || isShowerSelected ? '' : '_hidden'}.png`
                        : `/Common_Icon_Service_Booth${!selectedValue || isBoothSelected ? '' : '_hidden'}.png`
                    }
                    alt={t(option.labelKey)}
                  />
                  {option.disabled && option.disabledLabel && (
                    <div className="absolute -inset-x-16 -inset-y-2 flex items-center justify-center bg-gray-900/50 rounded-lg">
                      <span className="text-xs font-semibold text-white text-center whitespace-nowrap">
                        {option.disabledLabel}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
